<template>
  <div class="relative">
    <!-- <v-parallax
      :src="imgPath"
      class="w-[100%] object-cover max-h-[400px] brightness-75"
    > -->
    <img :src="imgPath" class="w-[100%] object-cover max-h-[500px] brightness-75  min-h-[200px]"/>
      <blockquote
        :cite="author"
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 container text-xl italic font-bold text-white text-center lg:w-[50%] w-[100%]"
      >
        <p class="text-md lg:text-xl">{{ quote }}</p>
        <p class="text-sm">{{ author }}</p>
      </blockquote>
    <!-- </v-parallax> -->
  </div>
</template>

<script>
export default {
  name: "BlockQuoteImage",
  props: {
    imageName: {
      type: String,
      required: true,
    },
    quote: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
  },
  computed: {
    imgPath() {
      return require(`@/assets/${this.imageName}`);
    },
  },
};
</script>